var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 167,
    viewBox: "0 0 161 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5718 2.94678H121.022C128.256 2.94678 134.395 8.86601 134.395 16.3199V135.801L123.433 149.393L112.472 136.239L101.729 149.393L91.2064 136.678L80.6833 149.174L70.3795 136.678L60.0756 149.174L49.5525 136.458L39.2487 148.954L28.0679 135.581V33.6391",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2605 45.2587H0.883545V15.2241C0.883545 7.11257 7.46049 0.535645 15.572 0.535645H15.7913C23.9028 0.535645 30.4797 7.11257 30.4797 15.2241V45.2587H30.2605Z",
    fill: "#4C565C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6506 29.2549H105.678",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6506 66.0854H105.678",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6506 47.6709H83.5353",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.397 166.275C149.047 166.275 160.924 154.398 160.924 139.748C160.924 125.097 149.047 113.221 134.397 113.221C119.746 113.221 107.87 125.097 107.87 139.748C107.87 154.398 119.746 166.275 134.397 166.275Z",
    fill: "#34A853"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.997 140.187L130.231 147.421L145.577 132.075",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6506 101.381C54.3776 95.9004 60.2968 87.3504 62.9276 88.0081C66.216 88.885 64.0237 100.504 65.9968 100.723C67.9699 100.943 72.1352 90.2004 75.6429 90.2004C78.7122 90.2004 76.9583 100.943 80.466 101.162C82.4391 101.381 85.7276 98.7504 91.2083 82.0889",
    stroke: "#4C565C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPaid);
export default __webpack_public_path__ + "static/media/billPaid.cd659043ad9ea6f7b4114e243f7cee08.svg";
export { ForwardRef as ReactComponent };